import { render, staticRenderFns } from "./Gruppen.vue?vue&type=template&id=69b11972&scoped=true&"
import script from "./Gruppen.vue?vue&type=script&lang=js&"
export * from "./Gruppen.vue?vue&type=script&lang=js&"
import style0 from "./Gruppen.vue?vue&type=style&index=0&id=69b11972&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b11972",
  null
  
)

export default component.exports